import GameScene from "../scenes/GameScene";
import { GameObject } from "./GameObject";

export class DecoSpawner {
	scene: GameScene;
	xPosition: number;

	readonly treeOffset: { [key: string]: number } = {
		tree1: 85,
		tree2: 178,
		tree3: 55,
		tree4: 45,
		tree5: 36,
	};

	readonly lvl1and2treeOffset: { [key: string]: number } = {
		tree1: 115,
		tree2: 8,
		tree3: 0,
		tree4: 150,
		tree5: 36,
	};

	constructor(scene: GameScene) {
		this.scene = scene;
		this.xPosition = -400;
	}

	update(): void {
		const screenDistance = this.scene.viewport.width > 1920 ? this.scene.viewport.width : 1920;
		const right = this.scene.cameras.main.scrollX + screenDistance;
		if (right + 800 > this.xPosition) {
			this.spawnChunk();
		}
	}

	spawnChunk(): void {
		const scene = this.scene;

		const bg = new GameObject(scene);
		bg.x = this.xPosition;
		scene.addObject(bg, "bg");
		bg.setSize(1920, 250);

		if (Math.random() > 0.5) this.createTrees(bg, ["tree1", "tree2"], 1, false);
		this.createTrees(bg, ["tree3", "tree4", "tree5"], Phaser.Math.RND.integerInRange(3, 5));

		const track = bg.addImage("mainHill");
		track.y = scene.upperLaneY + 125;
		track.setOrigin(0, 0.5);
		track.setDisplaySize(1920, 500);

		const topHill = bg.addImage("topHill");
		topHill.y = scene.upperLaneY - 125;
		topHill.setOrigin(0, 0.5);
		topHill.setScale(1920 / topHill.width);

		const foreground = new GameObject(scene);
		foreground.x = this.xPosition;
		scene.addObject(foreground, "foreground");
		foreground.setSize(1920, 250);

		const bottomHill = foreground.addImage("bottomHill");
		bottomHill.y = scene.lowerLaneY + 125 - 50;
		bottomHill.setOrigin(0, 0);
		bottomHill.setScale(1920 / bottomHill.width);

		this.xPosition += 1920;
	}

	createTrees(bgChunk: GameObject, images: string[], count: number, randomeScale = true): void {
		if (count <= 0) return;

		const levelName = this.scene.level.name;
		const treeOffset =
			levelName.includes("GreenCircle") || levelName.includes("BlueSquare") ? this.lvl1and2treeOffset : this.treeOffset;

		// need inital offset so that trees don't appear between seams
		const initalOffset = 70;
		const minOffset = 30;
		const xVariance = (bgChunk.width - minOffset * (count + 1) - initalOffset) / count;
		for (let i = 0; i < count; i++) {
			const minX = minOffset * (i + 1) + xVariance * i + initalOffset;
			const maxX = minX + xVariance;

			const tree = Phaser.Math.RND.pick(images);
			const image = bgChunk.addImage(tree);

			image.setOrigin(0, 1);
			image.setAngle(-this.scene.angle);
			if (randomeScale) image.setScale(Phaser.Math.RND.realInRange(0.85, 1.2));
			image.y = this.scene.upperLaneY - 25 + treeOffset[tree] * image.scaleY;
			image.x = Phaser.Math.RND.realInRange(minX, maxX);
		}
	}
}
